import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ofType } from "redux-observable";
import { authHeaders, getOrganisationBaseUrl } from "frame";
import Types from "../actions/types";
import { onAddFailed, onAddSuccess } from "../actions";

const leaveTypeAddEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.LEAVE_TYPE_CREATE_REQUESTED),
		filter(() => state$.value.organisations.currentOrganisation),
		mergeMap(({ payload }) =>
			ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/organisation-leave-type/create`,
					payload,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onAddSuccess(ajaxResponse.response))
					),
					catchError((error) => of(onAddFailed(error)))
				)
		)
	);

export default leaveTypeAddEffect;
